﻿import { IComponent, Component, Inject, Input, Output, Attribute, OutputArgs } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../../components/application"
import { DropdownEntry } from "../../controls/dropdownbox";
import { TranslationService } from "../../services/TranslationService";
import { IDisposable } from "../../interfaces/general";
import { LogService } from "../../services/logService";

@Component({
    module: FIQAssist,
    selector: "environmentdropdownbox",
    template: `<dropdownbox
                value-submit="$ctrl.passValueSubmit(selected)"
                read-only="$ctrl.readOnly" translate="true" multiselecttext="'MULTIPLE_ENVIRONMENTS_SELECTED'"
                multiselect="$ctrl.multiselect" tooltitle="{{'ENVIRONMENT' | translate}}{{($ctrl.tooltitle) ? ': ' + $ctrl.tooltitle : ''}}"
                hint="'Please choose an environment'" show-clear="{{$ctrl.showClear}}"
                selected="$ctrl._environments"
                items="$ctrl.items"
                iserror="$ctrl.iserror"
                child-classes="{{$ctrl.childClasses}}"
                onselectionchanged="$ctrl.environmentselected(selected)"></dropdownbox>`
})
class EnvironmentDropdownBox implements IComponent {
    private disposables: IDisposable[] = [];
    private _environments: any[];
    @Input() public readOnly: boolean;
    @Input() public iserror: boolean;

    constructor(
        @Inject() private translationService: TranslationService,
        @Inject() private logService: LogService
    ) { }

    $onInit() {
        this.items = [
            { key: 'na', text: 'N_A' },
            { key: 'prod', text: 'PRODUCTION' },
            { key: 'uat', text: 'UAT' }
        ];
        this.translations = [];
        this.items.forEach(element => {
            var sub = this.translationService.TranslateObservable(element.text).subscribe(t => this.translations[element.key] = t);
            this.disposables.push(() => sub.unsubscribe());
        });
        this.translations[""] = "";
    }

    $onDestroy() {
        this.disposables.forEach(d => {
            try { d() } catch (e) { this.logService.warning('DropDownBox', 'Error disposing', e); }
        });
    }

    private _childClasses;
    @Attribute() public get childClasses() {
        return this._childClasses;
    }
    public set childClasses(val: string) {
        this._childClasses = val;
    }

    private _showClear;
    @Attribute() public get showClear() {
        return this._showClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }

    @Input()
    public get environments(): any[] {
        return this._environments;
    }
    public set environments(envs: any[]) {
        this._environments = envs;
    }

    private translations = [];
    private items = [];

    public get tooltitle(): string {
        var tooltitle = "";
        if (this._environments) {
            this._environments.forEach(element => {
                tooltitle += `${this.translations[(element) ? element : ""]}, `;
            });
            return tooltitle.slice(0, tooltitle.lastIndexOf(', '));
        } else {
            return "";
        }
    }

    @Input() public multiselect: boolean;
    @Output() public onEnvironmentsChanged: OutputArgs<{ environments: any[] }>;
    public environmentselected(selected: any[]) {
        this.environments = selected;
        this.onEnvironmentsChanged({ environments: this.environments });
    }
    @Output() public valueSubmit: OutputArgs<{ environments: any[] }>;
    public passValueSubmit(selected: any[]) {
        this.environments = selected;
        if (this.valueSubmit) this.valueSubmit({ environments: this.environments });
    }
}
